import type { AllRouteEndpoints } from "../routeTypes";
export const appsUploadMessageCacheKeys: AllRouteEndpoints[] = [];
